import React from 'react';
import VerifyEmail from '../../components/VerifyEmail/VerifyEmail';
import Canonical from '../../utils/Canonical';

function VerifyEmailPage() {
  return (
    <div>
      <Canonical path='/verify-email' title='Verify Email | Bloggr.ai' />
      <VerifyEmail />
    </div>
  );
}

export default VerifyEmailPage;
